import axios from './http'

export default {
    getUnitMaster() {
        return axios.get('/product/itemunit')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getGroups() {
        return axios.get('/product/groups')
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    getSubgroups(parentCode) {
        return axios.get('/product/groups',{
            params:{
                parentCode: parentCode
            }
        })
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    getProductBrowse(params) {
        // var where = ""

        // if (params['cggroupsMode']) {
        //     where = "productcg_code="+params['cggroupsMode'];
        // } else if (params['subgroupsMode']) {
        //     where = "productsubgroup_code="+params['subgroupsMode'];
        // } else if (params['groupsMode']) {
        //     where = "productgroup_code="+params['groupsMode'];
        // }

        // if (params['keyword']) {
        //     if(where){
        //         where = "code=" + params['keyword'] + "&"+where;
        //     }else{
        //         where = "code=" + params['keyword'];
        //     }
        //     // if(where)
        //     // {
        //     //     where = "(code like %"+params['keyword']+"%) or (title like %"+params['keyword']+"%) or (title_th like %"+params['keyword']+"%) and "+ where
        //     // }else{
        //     //     where = "(code like %"+params['keyword']+"%) or (title like %"+params['keyword']+"%) or (title_th like %"+params['keyword']+"%)";
        //     // }
            
        // }

        // if(where != '')
        // {
        //     where += "&status=1&productlifecycle_code=['41','42','43','44','45','51','52','53','54']";
        // }

        return axios.get('/product/search',{
            params:{
                productcg_code: params['cggroupsMode'],
                productsubgroup_code: params['subgroupsMode'],
                productgroup_code: params['groupsMode'],
                keyword: params['keyword']
            }
        })
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });

        // if(where != '')
        //     where += " and (status = '1') and (productlifecycle_code in ['41','42','43','44','45','51','52','53','54'])";

        // return this.state.getUrl().get('/mst_product', {
        //         params: {
        //             "fields": "code,title_th,selling_um,productcg_code,cost,price",
        //             "filter": where,
        //             "limit": 100,
        //             "timestamp": new Date().getTime()
        //         }
        //     })
        //     .then(function (response) {
        //         return Promise.resolve(response.data.resource);
        //     })
        //     .catch(function (error) {
        //         return Promise.reject(error.response.error);
        //     });
    },
    search(keyword){
        return axios.get('/product/search', {
            params: {
                "keyword": keyword
            }
        })
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    getPrice(products){
        return axios.get('/product/get-price', {
            params: {
                "products": products
            }
        })
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },

    checkProductsImport(products){

        // let formData = new FormData();
        // formData.append("products", JSON.stringify(products));

        var formData = {
            products: products
        }

        return axios.post('/product/check-product-import', formData)
        .then(function (response) {
            return Promise.resolve(response);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
    },
    // searchTree(key) {
    //     return axios.get('/product/searchTree', {
    //           params: { key: key } 
    //         })
    //         .then(function (response) {
    //             return Promise.resolve(response);
    //         })
    //         .catch(function (error) {
    //             return Promise.reject(error);
    //         });
    // },
    ProductTree(code, type, dataDelete) {
        return axios.post('/product/searchTree', {
                pro_code: code,
                type: type,
                data_delete: dataDelete
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
    advancedSearch(keyword) {
        return axios.get('/product/advancedSearch', {
                params:{
                    keyword: keyword
                }
            })
            .then(function (response) {
                return Promise.resolve(response);
            })
            .catch(function (error) {
                return Promise.reject(error);
            });
    },
}